export const VNPUSHER_SET_CLUSTER = 'VNPUSHER_SET_CLUSTER'
export const VNPUSHER_SET_KEY = 'VNPUSHER_SET_KEY'
